import axios from "axios";
const isNewVersion = () => {
    let url = `//${window.location.host}/static/version.json?t=${new Date().getTime()}`
    axios.get(url).then(res =>{
        console.log(res,'ress');
        if(res.status === 200) {
            let vueVersion = res.data.version;
            let localVueVersion = localStorage.getItem('vueVersion');
            console.log(localVueVersion,vueVersion,'5');
            if(localVueVersion && localVueVersion !=vueVersion) {
                // console.log(localVueVersion);
                localStorage.setItem('vueVersion',vueVersion);
                window.location.reload();
                return;

            }else {
                localStorage.setItem('vueVersion',vueVersion)
            }
        }
    })
}

export default {
    isNewVersion
}


// WEBPACK FOOTER //
// ./src/libs/versionUpdate.js